import { Button, Text } from '@vallourec-ui/vallourec-ui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[24]};
  width: 100%;
  background: ${({ theme }) => theme.colors['neutral-color-5']};
`

export const Body = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[24]};

  > div {
    display: flex;
    flex: 1;
  }
`

export const SearchBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  margin: 0px 10px;
  width: 100%;
  position: relative;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: auto;
  overflow: hidden;
  justify-content: space-around;
`

export const ContentContainer = styled.div`
  display: block;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 400px;
  overflow: auto;
`

export const ButtonContainer = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  width: 100%;
  max-width: 15rem;
  margin: 0px 8px;
  width: ${({ width }) => width};
`

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: ${({ theme }) => theme.spacing[8]};
  padding-bottom: ${({ theme }) => theme.spacing[8]};
  white-space: nowrap;
  width: 100%;
`

export const StyledTextButton = styled.div`
  display: flex;
  white-space: nowrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[8]};
  justify-content: flex-start;
`

export const StyledText = styled(Text)`
  margin-top: 15px;
  margin-bottom: 15px;
`

export const StyledInputLabel = styled(Text)`
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a4c55;
`
